<template>
  <BreadCrumb PageTitle="Nouvelle réclamation" />
  <AddClaim />
</template>

<script lang="ts">
import { defineComponent } from "vue";
import BreadCrumb from "../../components/Common/BreadCrumb.vue";
import AddClaim from "../../components/Claims/AddClaim.vue";

export default defineComponent({
  name: "AddClaimPage",
  components: {
    BreadCrumb,
    AddClaim,
  },
});
</script>
